import React from "react";
import "./NotFound.css";
const NotFound = () => {
  return (
    <div className="err-img">
      <img
        src="https://i.ibb.co/k5SFSWZ/not-found.png"
        className="img-fluid"
        alt=""
      />
    </div>
  );
};

export default NotFound;
